module.exports = __webpack_public_path__ + "9de3148d3a5f8c86cba270d4d711ca1a.png";